import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
  GtagWrapper,
} from '@americanexpress/shared-scripts';

const GtagLocaleWrapper = ({ children }) => {
  /* istanbul ignore next */
  const gtagEnabledLocales = useSelector((state) => state.getIn(['config', 'gtagEnableLocale'])) || [];
  /* istanbul ignore next */
  const activeLocale = useSelector((state) => state.getIn(['intl', 'activeLocale']));

  if (children && gtagEnabledLocales && gtagEnabledLocales.includes(activeLocale)) {
    return (
      <>
        <GtagWrapper version="^1.0.0" />
        {children}
      </>
    );
  }
  return children;
};

/* istanbul ignore next */
GtagLocaleWrapper.propTypes = {
  children: PropTypes.node,
};

GtagLocaleWrapper.defaultProps = {
  children: null,
};

export default GtagLocaleWrapper;
